import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import VerifyingPage from "@/components/Base/VerifyingPage";
import { useAppSelector } from "@/stores/hooks";

export default function VerifyPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
      return;
    }
    const loginUrl = import.meta.env.VITE_LOGIN_URL;
    if (loginUrl) {
      window.location.href = loginUrl;
    }
  }, [isAuthenticated, navigate]);

  return <VerifyingPage />;
}
